import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

/* Sempadan ralat aplikasi.

   Tujuan: satu ralat masa jalan dalam satu komponen (contohnya pustaka peta)
   tidak boleh melumpuhkan keseluruhan aplikasi. Pengguna diberi mesej yang
   jelas dalam Bahasa Melayu dan satu butang untuk mencuba semula. */
export class SempadanRalat extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ralat: null };
  }

  static getDerivedStateFromError(ralat) {
    return { ralat };
  }

  componentDidCatch(ralat, info) {
    // Dicatat ke konsol supaya pasukan teknikal boleh menyiasat.
    console.error("Ralat masa jalan ditangkap oleh SempadanRalat:", ralat, info);
  }

  cubaSemula = () => this.setState({ ralat: null });

  render() {
    if (!this.state.ralat) return this.props.children;

    return (
      <div
        className="flex min-h-[60vh] items-center justify-center px-4 py-12"
        data-testid="sempadan-ralat"
      >
        <div className="max-w-md rounded-2xl border border-[color:var(--hairline)] bg-white p-6 text-center">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[rgba(140,18,25,0.10)] text-[color:var(--maroon)]">
            <AlertTriangle className="h-7 w-7" />
          </span>
          <h2 className="font-display mt-5 text-xl font-bold text-[color:var(--brand-navy)]">
            Ada sesuatu yang tidak berjalan lancar
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-[color:var(--ink-muted)]">
            Sebahagian halaman ini gagal dimuatkan. Data anda selamat. Sila cuba semula, atau muat
            semula pelayar jika masalah berterusan.
          </p>
          <div className="mt-6 flex flex-col gap-2.5 sm:flex-row sm:justify-center">
            <button
              type="button"
              onClick={this.cubaSemula}
              data-testid="sempadan-ralat-cuba-semula"
              className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-xl bg-[color:var(--maroon)] px-5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-[color:var(--maroon-gelap)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--focus)] focus-visible:ring-offset-2"
            >
              <RefreshCw className="h-4 w-4" /> Cuba semula
            </button>
            <button
              type="button"
              onClick={() => window.location.reload()}
              data-testid="sempadan-ralat-muat-semula"
              className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-xl border border-[color:var(--hairline)] bg-white px-5 text-sm font-semibold text-[color:var(--ink)] transition-colors duration-200 hover:border-[color:var(--brand-blue)] hover:text-[color:var(--brand-blue)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--focus)] focus-visible:ring-offset-2"
            >
              Muat semula halaman
            </button>
          </div>
        </div>
      </div>
    );
  }
}
